import { Tab, TabProps } from '@evaneos/b2b-ui';

export const PanelTab = (props: TabProps) => (
    <Tab
        disableRipple
        {...props}
        sx={{
            textTransform: 'none',
            color: 'text.primary',
            minHeight: 48,
            height: 48,
            fontSize: '1.4rem',
            '&.Mui-selected': { fontWeight: 'bold' },
            ...props.sx,
        }}
    />
);
